
.introDecoration {
    background-color: #ffe9e2;
    z-index: -1;
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
}

.doctorPortrait {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    /*min-width: 100%;*/
    max-height: 100%;
    /*margin-top: auto;*/
    /*margin-bottom: auto;*/
}

.doctorPortraitContainer {
    /*text-align: center;*/
}

.doctorIntroContent{
    color: #FFFFFF;
    background-color: #3caeb0;
    /*padding: 120px 60px;*/
}

.doctorIntroHeading {
    font-size: 32px;
    line-height: 1.1em;
}

@media(min-width: 768px) {
    .doctorIntroHeading {
        font-size: 50px;
    }
}
